module.exports = __webpack_public_path__ + "static/img/home_11_4.ba57e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePage_new/home_11_4.png
// module id = 50dM
// module chunks = 3 64